import { BorderRadius, Color, DefaultValue, Spacing, Tag as TagComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const BookkeepingTagSuggestion = styled.div`
  display: flex;
  align-items: center;
  padding: ${Spacing.S12} ${Spacing.S16};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Grey100};
`

export const ImageWrapper = styled.figure`
  margin-right: ${Spacing.S16};
`

export const ContentWrapper = styled.div``

export const TagsList = styled.div`
  margin-top: ${Spacing.S4};
`

export const Tag = styled(TagComponent)`
  margin-right: ${Spacing.S8};
  border-radius: ${DefaultValue.BorderRadius};
`
